import React, { useEffect, useState } from "react";
import API from "../utils/api";
import logo from '../karuncup.svg';
import { useSnackbar } from "notistack";

// انتظار پاسخ از بک‌اند:
// GET /api/terms/ -> { success: true, title: "...", content_html: "<p>...</p>", files: [ { title: "شرایط استفاده", url: "https://..." }, ... ] }
const TERMS_API = "/api/terms/";

const Terms = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await API.get(TERMS_API);
        if (!mounted) return;
        if (res.data && res.data.success) {
          setData(res.data);
        } else {
          enqueueSnackbar(res.data?.message || "خطا در دریافت قوانین.", { variant: 'error' });
        }
      } catch (err) {
        console.error(err);
        enqueueSnackbar(err?.response?.data?.message || "خطا در ارتباط با سرور.", { variant: 'error' });
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [enqueueSnackbar]);

  return (
    <div dir="rtl" lang="fa" className="w-full flex justify-center my-8 px-4">
      <div className="w-full max-w-5xl p-4 sm:p-8 bg-gradient-to-tr from-slate-900 to-slate-800 border border-slate-700 rounded-2xl shadow-lg text-right">
        <div className="flex items-center gap-4 mb-4">
          <img src={logo} className="w-12 h-12 sm:w-14 sm:h-14 rounded-md shadow-sm" alt="logo" />
          <div>
            <h1 className="text-lg sm:text-2xl font-extrabold text-white leading-tight">{data?.title || 'قوانین و مقررات'}</h1>
            <p className="text-slate-400 text-sm mt-1">لطفاً متن قوانین را با دقت مطالعه کنید. می‌توانید فایل‌های پیوست را دانلود نمایید.</p>
          </div>
        </div>

        {loading ? (
          <div className="text-slate-300">در حال بارگذاری...</div>
        ) : data ? (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <main className="lg:col-span-2 bg-slate-900/40 p-6 rounded-lg border border-slate-700 prose prose-invert text-slate-200 max-w-none">
              <div className="max-w-none" dangerouslySetInnerHTML={{ __html: data.content_html || data.content || "" }} />
            </main>

            <aside className="bg-slate-900/30 p-4 rounded-lg border border-slate-700 flex flex-col">
              <h3 className="text-white font-semibold mb-2">فایل‌های پیوست</h3>
              <p className="text-slate-400 text-sm mb-3">برای مشاهده کامل قوانین، فایل‌های زیر را دانلود کنید.</p>
              {Array.isArray(data.files) && data.files.length > 0 ? (
                <ul className="space-y-3">
                  {data.files.map((f, idx) => (
                    <li key={idx} className="flex items-center justify-between bg-slate-900 p-3 rounded-md border border-slate-700">
                      <div className="flex items-center gap-3">
                        <span className="inline-flex items-center justify-center w-9 h-9 bg-slate-800 rounded-md text-lime-400">📄</span>
                        <div>
                          <div className="text-slate-200 font-medium">{f.title || `فایل ${idx + 1}`}</div>
                          {f.description && <div className="text-slate-400 text-xs">{f.description}</div>}
                        </div>
                      </div>
                      <a href={f.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm bg-lime-500 hover:bg-lime-400 text-black px-3 py-2 rounded-md">دانلود</a>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="text-slate-400">فایلی برای دانلود وجود ندارد.</div>
              )}

              <div className="mt-4 pt-4 mx-auto ">
                <a href="/" className="text-sm text-slate-300 hover:underline">بازگشت به صفحه اصلی</a>
              </div>
            </aside>
          </div>
        ) : (
          <div className="text-slate-300">داده‌ای برای نمایش موجود نیست.</div>
        )}
      </div>
    </div>
  );
};

export default Terms;
